import {ValidationPriority} from '@lib/store/src/ui/hooks/timeslots/useDaySchedule';
import {cn, pxToRem} from '@utils';
import {Icon} from 'src/components/atoms/Icon';

interface ValidationMessageProps {
  message: string;
  priority?: ValidationPriority;
}

export const ValidationMessage = ({message, priority = ValidationPriority.Low}: ValidationMessageProps) => {
  return (
    <div
      className={cn('flex items-start gap-4 p-4 rounded-lg', {
        'bg-functional-red/10': priority === ValidationPriority.High,
        'bg-functional-orange/10': priority === ValidationPriority.Low,
      })}>
      <div
        className={cn('flex items-center justify-center mt-0.5 w-4 h-4 rounded-full', {
          'bg-functional-red': priority === ValidationPriority.High,
          'bg-inspiring-orange-400': priority === ValidationPriority.Low,
        })}>
        <Icon
          icon={priority === ValidationPriority.High ? 'close' : 'info'}
          size={pxToRem(12)}
          className="text-white"
          color="currentColor"
        />
      </div>

      <div className="flex-1">
        <p>{message}</p>
      </div>
    </div>
  );
};
